/* Tell the shopper the truth about the button they are pressing.

   The product page renders two buy buttons. The real one lives in the form and
   the theme disables it when the selected variant cannot be bought. The one
   the shopper actually sees and presses — .dummy-add-to-cart, inside the
   description block — is rendered once by Liquid from `product.available`,
   which is true if ANY variant of the product has stock, and is never updated
   again. So on a sold-out size it still reads ADD TO CART, forwards a click to
   a disabled button, and nothing happens: it reads as a broken site rather
   than as a sold-out size.

   An earlier version of this file mirrored the real button's state onto the
   decoy. That was the wrong idea — it made this file depend on theme internals
   that change between variant renders, and in at least one state the buttons
   vanished entirely, which is worse than the bug it was fixing.

   This version depends on nothing but the variant JSON the theme already
   inlines for its own use, the same source the buckle drawer reads. Three
   states, and the button is never hidden in any of them:

     ok           the variant exists and can be bought — leave everything alone
     sold out     the variant exists but has no stock
     unavailable  this combination of options was never made

   The last one matters here: Croc99 comes in 16mm and 23mm only in Sharp
   Tuxedo with Red Lining, so most colours have two sizes that are not "out of
   stock" but simply do not exist. Saying "sold out" there would be a lie. */

(function () {
  'use strict';

  if (window.__wcAtcState) return;
  window.__wcAtcState = true;

  var COPY = {
    soldout: 'This size and colour is sold out. Please choose another.',
    unavailable: 'This combination isn’t available. Please choose another size or colour.'
  };

  var LABEL = { ok: null, soldout: 'SOLD OUT', unavailable: 'UNAVAILABLE' };

  function style() {
    if (document.getElementById('wc-atc-state-css')) return;
    var s = document.createElement('style');
    s.id = 'wc-atc-state-css';
    s.textContent =
      /* Nothing this file does may ever remove the buy button from the page. */
      '.dummy-buttons-wrapper{display:flex !important;}' +
      '.dummy-add-to-cart{display:flex !important;}' +
      '.dummy-add-to-cart.wc-unbuyable,.dummy-buy-now.wc-unbuyable{' +
        'background-color:#ffffff !important;color:#9a9a9a !important;' +
        'border:1px solid #d8d8d8 !important;cursor:not-allowed;opacity:1 !important;}' +
      '.wc-atc-note{margin:-20px 0 26px;font-size:1.3rem;line-height:1.5;' +
        'color:#b3261e;letter-spacing:.02em;}' +
      '.wc-atc-note[hidden]{display:none !important;}';
    document.head.appendChild(s);
  }

  /* The theme inlines the selected variant for its own price and button
     rendering. When the chosen combination does not exist it inlines null,
     which is exactly the signal needed to tell "never made" from "sold out". */
  function selectedVariant() {
    var el = document.querySelector('variant-selects script[data-selected-variant]');
    if (!el) return undefined;              // no picker on this page
    try { return JSON.parse(el.textContent); } catch (e) { return undefined; }
  }

  function stateNow() {
    var v = selectedVariant();
    if (v === undefined) return 'ok';       // nothing to judge — stay out of the way
    if (v === null) return 'unavailable';
    return v.available === false ? 'soldout' : 'ok';
  }

  function note(wrapper) {
    var el = wrapper.parentNode.querySelector('.wc-atc-note');
    if (!el) {
      el = document.createElement('p');
      el.className = 'wc-atc-note';
      el.setAttribute('role', 'status');
      el.hidden = true;
      wrapper.parentNode.insertBefore(el, wrapper.nextSibling);
    }
    return el;
  }

  var state = 'ok';

  function paint() {
    var wrapper = document.querySelector('.dummy-buttons-wrapper');
    var atc = document.querySelector('.dummy-add-to-cart');
    if (!wrapper || !atc) return;

    state = stateNow();
    var bad = state !== 'ok';

    if (!atc.getAttribute('data-wc-label')) {
      atc.setAttribute('data-wc-label', (atc.textContent || 'ADD TO CART').trim());
    }

    var text = bad ? LABEL[state] : atc.getAttribute('data-wc-label');
    if ((atc.textContent || '').trim() !== text) atc.textContent = text;

    atc.classList.toggle('wc-unbuyable', bad);
    atc.setAttribute('aria-disabled', bad ? 'true' : 'false');
    /* Deliberately NOT the disabled attribute: a disabled button swallows the
       click, and the click is how the message gets shown to someone who taps
       it anyway. */
    atc.disabled = false;

    var buy = document.querySelector('.dummy-buy-now');
    if (buy) {
      buy.classList.toggle('wc-unbuyable', bad);
      buy.setAttribute('aria-disabled', bad ? 'true' : 'false');
    }

    /* The message only appears once they have actually tried. */
    if (!bad) note(wrapper).hidden = true;
  }

  function explain() {
    var wrapper = document.querySelector('.dummy-buttons-wrapper');
    if (!wrapper) return;
    var el = note(wrapper);
    el.textContent = COPY[state] || COPY.unavailable;
    el.hidden = false;
    if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  /* Capture phase, so this runs before the theme's own handler forwards the
     click to a button that cannot accept it. */
  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.dummy-add-to-cart, .dummy-buy-now');
    if (!hit) return;
    if (state === 'ok') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    explain();
  }, true);

  function watch() {
    var host = document.querySelector('product-info')
      || document.querySelector('.product__info-wrapper');
    if (!host || !window.MutationObserver) return;

    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; paint(); }, 60);
    }).observe(host, { childList: true, subtree: true });
  }

  function boot() {
    if (!document.querySelector('.dummy-add-to-cart')) return;   // not a product page
    style();
    paint();
    watch();
    document.addEventListener('change', function () { setTimeout(paint, 80); }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
